import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function HeroSection() {
  const hotArticles = getHotArticles().slice(0, 3);

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20coral%20red%20and%20deep%20charcoal%20gradients%2C%20soft%20overlapping%20circles%20and%20organic%20shapes%2C%20dark%20background%20with%20vibrant%20warm%20accents%2C%20modern%20editorial%20design%2C%20minimalist%20aesthetic%2C%20smooth%20color%20transitions%2C%20artistic%20and%20energetic%20composition%2C%20no%20text%2C%20no%20people%2C%20abstract%20art%20style&width=1800&height=800&seq=hero-bg-51chigua&orientation=landscape"
          alt="51吃瓜大赛背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="mb-6">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-400 text-xs font-medium">
            <i className="ri-fire-line text-sm"></i>
            实时追踪 · 每日更新
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
          51吃瓜大赛
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-2 text-background-50/90">
            一手吃瓜资源实时放送
          </span>
        </h1>

        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚51吃瓜网站、51吃瓜在线观看入口，每日更新黑料吃瓜爆料，
          追踪网红塌房、明星黑料、热门大赛，最全吃瓜资讯尽在51吃瓜大赛
        </p>

        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line"></i>
            进入吃瓜大赛
          </Link>
          <Link
            to="/category/wanghong-tafang"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-lg border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
          >
            浏览热门爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {hotArticles.map((article, i) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative bg-background-50/10 backdrop-blur-sm border border-background-50/10 rounded-xl p-4 text-left hover:bg-background-50/15 transition-all cursor-pointer"
              style={{
                transform: i === 0 ? 'translateY(-8px)' : i === 2 ? 'translateY(-8px)' : 'translateY(0px)',
              }}
            >
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <span className="inline-block text-[10px] font-medium text-accent-400 bg-accent-500/15 px-1.5 py-0.5 rounded mb-1">
                    {article.category}
                  </span>
                  <h3 className="text-sm font-medium text-white group-hover:text-accent-400 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-background-50/50 mt-1">
                    {article.views.toLocaleString()} 次围观 · {article.comments.toLocaleString()} 评论
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}